"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WeekPicker = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importStar(require("react"));
var react_common_lib_1 = require("@esub-engineering/react-common-lib");
var pickers_1 = require("@material-ui/pickers");
var date_fns_1 = __importDefault(require("@date-io/date-fns"));
var core_1 = require("@material-ui/core");
var icons_1 = require("../../icons");
var Button_1 = require("../../atoms/Button");
var atoms_1 = require("../../atoms");
var styles_1 = __importDefault(require("./styles"));
var types_1 = require("../../types");
exports.WeekPicker = react_1.default.memo(function (_a) {
    var start = _a.start, end = _a.end, onChange = _a.onChange;
    var classes = (0, styles_1.default)();
    var _b = (0, react_1.useState)(false), showCalendar = _b[0], setShowCalendar = _b[1];
    var clickOnCalendar = (0, react_1.useCallback)(function () {
        setShowCalendar(function (prev) { return !prev; });
    }, []);
    var onChangeDate = (0, react_1.useCallback)(function (date) {
        onChange(types_1.WeekPickerDateDirection.SET, date);
        setShowCalendar(false);
    }, [onChange]);
    return ((0, jsx_runtime_1.jsxs)(core_1.Grid, __assign({ container: true }, { children: [(0, jsx_runtime_1.jsx)(core_1.Grid, __assign({ item: true, xs: 12 }, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ className: classes.root }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: classes.alignAndJustify }, { children: (0, jsx_runtime_1.jsx)(Button_1.Button, __assign({ id: "DecrementWeekButton", "data-testid": "DecrementWeekButton", className: classes.decrementWeekButton, variant: "text", size: "small", onClick: function () { return onChange(types_1.WeekPickerDateDirection.DECREASE); } }, { children: (0, jsx_runtime_1.jsx)(atoms_1.Icon, __assign({ size: "small", fontWeight: "bold" }, { children: (0, jsx_runtime_1.jsx)(icons_1.ChevronLeft, {}) })) })) })), (0, jsx_runtime_1.jsxs)(atoms_1.Text, __assign({ className: classes.text }, { children: ["".concat((0, react_common_lib_1.dateFormat)(start, "mdy"), " - ").concat((0, react_common_lib_1.dateFormat)(end, "mdy")), (0, jsx_runtime_1.jsx)("span", __assign({ className: classes.calendarIcon }, { children: (0, jsx_runtime_1.jsx)(atoms_1.Icon, __assign({ size: "small", id: "CalendarIconButton", "data-testid": "CalendarIconButton", onClick: clickOnCalendar, className: classes.calendarImage }, { children: (0, jsx_runtime_1.jsx)(icons_1.Calendar, {}) })) }))] })), (0, jsx_runtime_1.jsx)("div", __assign({ className: classes.alignAndJustify }, { children: (0, jsx_runtime_1.jsx)(Button_1.Button, __assign({ id: "IncrementWeekButton", "data-testid": "IncrementWeekButton", className: classes.incrementWeekButton, variant: "text", size: "small", onClick: function () { return onChange(types_1.WeekPickerDateDirection.INCREASE); } }, { children: (0, jsx_runtime_1.jsx)(atoms_1.Icon, __assign({ size: "small" }, { children: (0, jsx_runtime_1.jsx)(icons_1.ChevronRight, {}) })) })) }))] })) })), (0, jsx_runtime_1.jsx)(core_1.Grid, __assign({ item: true, xs: 12 }, { children: showCalendar && ((0, jsx_runtime_1.jsx)("div", __assign({ className: classes.datePicker, "data-testid": "SetWeekCalendar" }, { children: (0, jsx_runtime_1.jsx)(pickers_1.MuiPickersUtilsProvider, __assign({ utils: date_fns_1.default }, { children: (0, jsx_runtime_1.jsx)(pickers_1.DatePicker, { id: "SetWeekCalendar", variant: "static", autoOk: true, value: start, onChange: function (date) { return onChangeDate(date); } }) })) }))) }))] })));
});
exports.WeekPicker.displayName = "WeekPicker";
